import { render } from "./SequestrateList.vue?vue&type=template&id=4e91a836"
import script from "./SequestrateList.vue?vue&type=script&lang=js"
export * from "./SequestrateList.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__